import {Localized} from "@fluent/react";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import {Box, IconButton, InputAdornment, TextField} from "@mui/material";
import React, {useRef, useState} from "react";

function TitleEditor(props: {
	label: React.ReactNode;
	initialValue: string;
	onSave: (value: string) => void;
	onCancel: () => void;
}) {
	const title = useRef<HTMLInputElement>(null);
	const [empty, setEmpty] = useState(false);

	function save() {
		const value = title.current?.value ?? "";

		if (value === "") {
			setEmpty(true);
			return;
		}

		props.onSave(value);
	}

	return (
		<form
			onSubmit={(e) => {
				e.preventDefault();
				save();
			}}
		>
			<TextField
				inputRef={title}
				label={props.label}
				defaultValue={props.initialValue}
				fullWidth
				error={empty}
				helperText={
					empty && (
						<Localized id="learning-material-title-error-required-field">
							This field is required
						</Localized>
					)
				}
				slotProps={{
					input: {
						endAdornment: (
							<InputAdornment position="end">
								<Box mr={1}>
									<IconButton size="small" onClick={props.onCancel}>
										<ClearIcon fontSize="inherit" />
									</IconButton>
								</Box>
								<Box>
									<IconButton size="small" type="submit">
										<CheckIcon fontSize="inherit" color="success" />
									</IconButton>
								</Box>
							</InputAdornment>
						),
					},
				}}
				onChange={() => {
					setEmpty(false);
				}}
			/>
		</form>
	);
}

export default TitleEditor;
